import React, { useEffect, useState } from "react";
import { getBidderByUuid } from "services";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { Button } from "../../../../../../shadcn/components/ui/button";

interface JBCompletedStatusComponentProps {
  bidderUuid: any;
}

export default function JBCompletedStatusComponent({
  bidderUuid,
}: JBCompletedStatusComponentProps) {
  const [loading, setLoading] = useState(false);
  const [finalApprovalStatus, setFinalApprovalStatus] = useState("pending");
  const [bidder, setBidder] = useState<any>(null);
  const router = useRouter();
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const init = async (bidderUuid: any) => {
    setLoading(true);
    if (bidderUuid) {
      try {
        const data: any = await getBidderByUuid(bidderUuid);
        setBidder(data);
        if (data?.status === "pending") {
          setFinalApprovalStatus("pending");
        } else if (data?.status === "rejected") {
          setFinalApprovalStatus("rejected");
        } else if (data?.status === "verified") {
          setFinalApprovalStatus("verified");
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    init(bidderUuid);
  }, [bidderUuid]);
  return (
    <div>
      <div>
        <h2 className="text-lg lg:text-xl font-semibold mb-4">
          Submission completed
        </h2>
        <div className="mt-4 mb-14">
          {finalApprovalStatus === "pending" && <KYCApprovalPending />}
          {finalApprovalStatus === "verified" && <KYCApproved />}
          {finalApprovalStatus === "rejected" && (
            <KYCApprovalRejected bidder={bidder} />
          )}
        </div>
      </div>
    </div>
  );
}

const KYCApprovalPending = () => {
  return (
    <div className="flex items-center space-x-3 p-4 bg-green-100 border-l-4 border-green-500 rounded-md">
      <div className="min-w-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-6 h-6 text-green-600"
        >
          <circle
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeMiterlimit={10}
            cx={16}
            cy={16}
            r={12}
          />
          <rect x={15} y={14} width={2} height={8} fill="currentColor" />
          <rect x={15} y={10} width={2} height={2} fill="currentColor" />
        </svg>
      </div>
      <p className="text-green-800 text-sm font-medium">
        Your auction participation application is currently under review by the
        bank. This process may take some time. Please check back later.
      </p>
    </div>
  );
};
const KYCApproved = () => {
  return (
    <div className="flex items-center p-4 bg-green-100 border-l-4 border-green-400 rounded-md">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-6 h-6 text-green-600"
      >
        <circle
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeMiterlimit={10}
          cx={16}
          cy={16}
          r={12}
        />
        <rect x={15} y={14} width={2} height={8} fill="currentColor" />
        <rect x={15} y={10} width={2} height={2} fill="currentColor" />
      </svg>
      <p className="text-green-800 text-sm font-medium ml-3">
        Your application has been approved by the banker. You can now view your
        event in the{" "}
        <a
          href="/auction-events"
          className="text-green-600 font-semibold hover:underline"
        >
          My Events
        </a>{" "}
        section.
      </p>
    </div>
  );
};
const KYCApprovalRejected = ({ bidder }: { bidder: any }) => {
  return (
    <div className="flex items-start gap-3 px-6 py-5 bg-red-50 border border-red-200 rounded-lg">
      <div className="flex-shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01M12 19a7 7 0 100-14 7 7 0 000 14z"
          />
        </svg>
      </div>
      <div>
        <p className="text-xs md:text-base font-semibold text-red-800">
          Your bid participation application has been{" "}
          <span className="font-bold">rejected</span> by the banker.
        </p>

        <p className="mt-2 text-xs md:text-sm text-gray-700">
          <span className="font-semibold text-gray-800">Reason: </span>
          <span className="text-gray-600">
            {bidder?.remarks?.trim() || "Rejected without a specified reason."}
          </span>
        </p>

        <p className="mt-3 text-xs text-gray-500 italic">
          You can contact your banker for clarification, or reach out to the
          Auction Bazaar support team for assistance.
        </p>
      </div>
    </div>
  );
};
